export function ProgressBar({ value, max }: { value: number; max: number }) {
  const percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className="progress-bar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max} role="progressbar">
      <span style={{ width: `${percent}%` }} />
    </div>
  );
}
